import L from "../../libs/leaflet";

export function getDefaultMarkerIcon() {
    return L.icon({
        iconUrl: "https://cdn-icons-png.flaticon.com/512/64/64113.png",
        iconSize: [30, 30],
        iconAnchor: [15, 30],
    });
}
